/* Header, homepage and grouped results share one explicit scooter selection. */
(function () {
  'use strict';
  const root = document.querySelector('[data-parts-shell]');
  if (!root || window.EsvPartsVehicle) return;
  const storageKey = 'esv:parts:vehicle';
  let memory = '', catalogue, pending, liveVehicles;
  try { memory = sessionStorage.getItem(storageKey) || ''; } catch (_) { /* In-memory selection still works. */ }
  const get = () => memory;
  function set(id, origin = 'shell') {
    id = String(id || '');
    if (id && (!id.startsWith('sf-') || (catalogue && !catalogue.vehicles.some(v => v.id === id)))) return;
    const changed = memory !== id;
    memory = id;
    try { sessionStorage.setItem(storageKey, id); } catch (_) { /* Link parameters remain available. */ }
    if (changed) document.dispatchEvent(new CustomEvent('esv:vehicle-change', { detail: { id, origin } }));
  }
  async function load() {
    if (catalogue) return catalogue;
    if (pending) return pending;
    pending = Promise.all([(async () => {
      const vehicles = liveVehicles || await window.EsvShopifyCatalog.loadVehicles();
      // A missing remembered model must be checked against the live catalogue.
      if (vehicles && (!memory || vehicles.some(v => v.id === memory))) return { version: 2, vehicles };
      return window.EsvShopifyCatalog.load();
    })(), (async () => {
      const url = root.dataset.groupsUrl;
      const response = await fetch(url, { signal: AbortSignal.timeout(15000) });
      if (!response.ok) throw new Error('Catalogue unavailable');
      return response.json();
    })()]).then(([data, categories]) => {
      if (data.version !== 2 || !Array.isArray(data.vehicles) ||
          data.vehicles.some(v => !v.id || !v.brandId || !v.brand || !v.label) || !Array.isArray(categories.groups)) throw new Error('Incomplete catalogue');
      catalogue = { vehicles: liveVehicles || data.vehicles, groups: categories.groups };
      if (memory && !catalogue.vehicles.some(v => v.id === memory)) set('');
      return catalogue;
    }).catch(error => { pending = null; throw error; });
    return pending;
  }
  function url(path, vehicle = get()) {
    const target = new URL(path, location.origin);
    if (target.origin !== location.origin) throw new Error('Invalid storefront link');
    if (root.dataset.theme) target.searchParams.set('preview_theme_id', root.dataset.theme);
    else target.searchParams.delete('preview_theme_id');
    if (vehicle) { target.searchParams.set('esv_vehicle', vehicle); target.searchParams.delete('esv_vehicle_off'); }
    else { target.searchParams.delete('esv_vehicle'); target.searchParams.set('esv_vehicle_off', '1'); }
    return target.href;
  }
  window.EsvPartsVehicle = { get, set, load, url };
  function fromUrl() {
    const params = new URL(location.href).searchParams;
    if (params.get('esv_vehicle_off') === '1') set('', 'url');
    else if (params.has('esv_vehicle')) set(params.get('esv_vehicle'), 'url');
  }
  fromUrl(); window.addEventListener('popstate', fromUrl);
  const dialog = document.querySelector('#EsvVehicleDialog');
  let opener;
  document.querySelectorAll('[data-parts-vehicle-open]').forEach(button => button.addEventListener('click', () => {
    const headerForm = dialog.querySelector('[data-parts-vehicle-form]');
    if (headerForm) ensureSetup(headerForm);
    opener = button; dialog.showModal();
    dialog.querySelector('[data-parts-vehicle-close]').focus();
  }));
  dialog.querySelector('[data-parts-vehicle-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => {
    const rect = dialog.getBoundingClientRect();
    if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) dialog.close();
  });
  dialog.addEventListener('close', () => opener?.focus());
  function reflectHeader() {
    const selected = catalogue?.vehicles.find(v => v.id === get());
    document.querySelectorAll('[data-parts-vehicle-name]').forEach(node => { node.textContent = selected?.label || 'Scooter auswählen'; node.title = node.textContent; });
    document.querySelectorAll('[data-parts-vehicle-open]').forEach(button => button.setAttribute('aria-label', selected ? `Scooter ändern: ${selected.label}` : 'Scooter auswählen'));
    document.querySelectorAll('[data-parts-category-link]').forEach(link => { link.href = url(link.href); });
  }
  document.addEventListener('esv:catalogue-ready', event => {
    liveVehicles = event.detail.vehicles;
    if (!catalogue || JSON.stringify(catalogue.vehicles) === JSON.stringify(liveVehicles)) return;
    catalogue.vehicles = liveVehicles;
    reflectHeader();
    document.dispatchEvent(new CustomEvent('esv:vehicles-change'));
  });
  document.addEventListener('esv:vehicle-change', () => {
    reflectHeader();
    // The header names the selected scooter; fetch the shared catalogue only once a scooter is chosen.
    if (get() && !catalogue) load().then(reflectHeader, () => {});
  });
  function requestVehicle(target, detail) {
    const scope = target.closest('[data-parts-vehicle-form], [data-esv-search]');
    const brand = scope?.querySelector('[data-parts-brand], [data-brand]');
    const typedBrand = scope?.querySelector('[data-picker-input$="brand"]');
    const typedModel = scope?.querySelector('[data-picker-input$="model"]');
    const brandName = detail?.kind === 'brand' ? detail.query : typedBrand?.dataset.pickerDraft ?? (brand?.value ? brand.selectedOptions[0]?.textContent : '');
    const modelName = detail?.kind === 'brand' || (!detail && typedBrand?.dataset.pickerDraft !== undefined) ? '' : detail?.query ?? typedModel?.dataset.pickerDraft ?? typedModel?.value ?? '';
    const redundantBrand = String(modelName).toLocaleLowerCase('de').startsWith(String(brandName).toLocaleLowerCase('de') + ' ');
    const name = [redundantBrand ? '' : brandName, modelName].filter(Boolean).join(' ').slice(0, 200);
    const targetUrl = new URL(url(root.dataset.searchUrl, ''));
    targetUrl.searchParams.set('esv_inquiry', '1');
    if (name) targetUrl.searchParams.set('esv_inquiry_vehicle', name);
    location.assign(targetUrl.href);
  }
  document.addEventListener('esv:vehicle-request', event => requestVehicle(event.target, event.detail));
  document.querySelectorAll('[data-parts-vehicle-request]').forEach(link => link.addEventListener('click', event => {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault(); requestVehicle(link);
  }));
  const option = (value, label) => new Option(label, value);
  async function setup(form) {
    const status = form.querySelector('[data-parts-form-status]');
    const retry = form.querySelector('[data-parts-retry]');
    retry.hidden = true; status.textContent = 'Scooter-Auswahl wird geladen …';
    try {
      await load();
      const brand = form.querySelector('[data-parts-brand]'), model = form.querySelector('[data-parts-model]');
      const submit = form.querySelector('[data-parts-submit]'), clear = form.querySelector('[data-parts-clear]');
      function fillBrands() {
        const selected = brand.value;
        const brands = [...new Map(catalogue.vehicles.map(v => [v.brandId, v.brand]))].sort((a, b) => a[1].localeCompare(b[1], 'de'));
        brand.replaceChildren(option('', 'Marke auswählen'), ...brands.map(([id, name]) => option(id, name)));
        brand.value = selected;
      }
      fillBrands();
      let pickers = [];
      function reflect() {
        const selected = catalogue.vehicles.find(v => v.id === get());
        if (selected) brand.value = selected.brandId;
        model.replaceChildren(option('', brand.value ? 'Modell auswählen' : 'Zuerst Marke auswählen'), ...window.EsvPartsCatalog.models(catalogue.vehicles, brand.value).map(v => option(v.id, v.label)));
        model.disabled = !brand.value; model.value = selected?.id || '';
        submit.disabled = !model.value; clear.hidden = !selected;
        pickers.forEach(p => p.sync());
        status.textContent = '';
      }
      form.querySelector('fieldset').disabled = false; reflect();
      if (window.EsvSearchPicker) pickers = [window.EsvSearchPicker.attach(brand, form.dataset.partsVehicleForm + '-brand'), window.EsvSearchPicker.attach(model, form.dataset.partsVehicleForm + '-model')];
      brand.addEventListener('change', () => { set(''); reflect(); (form.querySelector('[data-picker-input$="-model"]') || model).focus(); });
      model.addEventListener('change', () => { set(model.value); reflect(); });
      clear.addEventListener('click', () => { brand.value = ''; set(''); reflect(); });
      document.addEventListener('esv:vehicle-change', reflect);
      document.addEventListener('esv:vehicles-change', () => { fillBrands(); reflect(); });
      form.addEventListener('submit', event => {
        event.preventDefault();
        if (!model.value) return;
        set(model.value);
        if (form.dataset.partsVehicleForm === 'header') dialog.close();
        else location.assign(url(form.querySelector('[data-parts-category]')?.value || root.dataset.searchUrl));
      });
      reflectHeader();
    } catch (_) {
      status.textContent = 'Die Scooter-Auswahl konnte nicht geladen werden. Suche nach einem Teil oder öffne eine Kategorie.';
      retry.hidden = false;
    }
  }
  const setups = new WeakMap();
  function ensureSetup(form) {
    if (!setups.has(form)) setups.set(form, setup(form));
    return setups.get(form);
  }
  document.querySelectorAll('[data-parts-vehicle-form]').forEach(form => {
    form.querySelector('[data-parts-retry]').addEventListener('click', () => setups.set(form, setup(form)));
    // The header dialog starts closed: build its scooter list on first open, unless a scooter is already selected.
    if (form.dataset.partsVehicleForm !== 'header' || get()) ensureSetup(form);
  });
  reflectHeader();
  document.querySelector('[data-parts-expand]')?.addEventListener('click', event => {
    const button = event.currentTarget, expanded = button.getAttribute('aria-expanded') !== 'true';
    document.querySelectorAll('[data-parts-extra-category]').forEach(card => { card.hidden = !expanded; });
    button.setAttribute('aria-expanded', String(expanded));
    button.firstChild.textContent = expanded ? 'Weniger Kategorien anzeigen ' : 'Alle Kategorien anzeigen ';
  });
  document.addEventListener('click', event => {
    const advice = event.target.closest('[data-parts-advice]');
    if (!advice || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const widget = document.querySelector('[data-ai-chat]'), toggle = widget?.querySelector('[data-ai-chat-toggle]'), input = widget?.querySelector('[data-ai-chat-input]');
    if (!toggle || !input || input.disabled) return;
    document.querySelector('.head-slot-nav-mobile-link[aria-expanded="true"]')?.click();
    if (widget.querySelector('[data-ai-chat-panel]').dataset.open !== 'true') toggle.click();
    if (widget.querySelector('[data-ai-chat-panel]').dataset.open !== 'true') return;
    event.preventDefault(); if (dialog.open) dialog.close();
    const selected = catalogue?.vehicles.find(v => v.id === get());
    input.value = selected ? `Ich suche ein Ersatzteil für ${selected.label}. ` : 'Ich brauche Hilfe bei der Auswahl eines Ersatzteils. ';
    input.dispatchEvent(new Event('input', { bubbles: true })); input.focus();
  });
  document.addEventListener('keydown', event => { if (event.key === 'Escape') document.querySelectorAll('.esv-catalog-menu[open]').forEach(menu => { menu.open = false; menu.querySelector('summary').focus(); }); });
  document.addEventListener('click', event => document.querySelectorAll('.esv-catalog-menu[open]').forEach(menu => { if (!menu.contains(event.target)) menu.open = false; }));
})();
